module.exports = __webpack_public_path__ + "img/f36.ada198bb.jpg";